import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { editingHelpCenter } from '@helpcenter/help-center-preview';
import { customizingRequestListColumn } from '@helpcenter/requests-column-settings';
import type { State } from 'state';
import { getPortalId } from 'state/selectors/context';
import { getJsmAIConfigEnabled } from 'state/selectors/env';
import { getCanCustomize } from 'state/selectors/help-center';
import {
    getName,
    getPortalAnnouncement,
    getCanAdministerProject,
    getIsProjectSimplified,
    getProjectKey,
} from 'state/selectors/portal';
import { getRequestsColumnSettings } from 'state/selectors/requests-column-settings';
import { getCanAdministerJIRA } from 'state/selectors/user';

import { CustomiseMenuDumb } from '../customise-menu-dumb';

const selector = createSelector(
    (state: State) => {
        const portalId = getPortalId(state);
        const portal = {
            id: portalId,
            name: getName(state, portalId),
            canEditAnnouncement: Boolean(getPortalAnnouncement(state, portalId)?.canEditAnnouncement),
            isProjectAdmin: Boolean(getCanAdministerProject(state, portalId)),
            isProjectSimplified: Boolean(getIsProjectSimplified(state, portalId)),
        };

        return {
            portal,
            canAdministerJIRA: getCanAdministerJIRA(state),
            canCustomiseHelpCenter: getCanCustomize(state),
            defaultColumnSettings: getRequestsColumnSettings(state),
            jsmAIConfigEnabled: getJsmAIConfigEnabled(state),
            projectKey: getProjectKey(state, portalId),
        };
    },
    ({ portal, canAdministerJIRA, canCustomiseHelpCenter, defaultColumnSettings, jsmAIConfigEnabled, projectKey }) => ({
        portal,
        canAdministerJIRA,
        canCustomiseHelpCenter,
        defaultColumnSettings,
        jsmAIConfigEnabled,
        projectKey,
    })
);

export default connect(selector, {
    openHelpCenterCustomizationSidebar: () => editingHelpCenter(true),
    openRequestListCustomizationSidebar: () => customizingRequestListColumn(true),
})(CustomiseMenuDumb);
